import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { styled } from '@mui/system';
import { Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import logo from '../assets/logo.png';
import * as Util from '../Util';
import authService from '../services/authService';
import LoadingOverlay from '../core/components/LoadingOverlay';

const Background = styled(Box)(({ theme }) => ({
  backgroundPosition: 'bottom right',
  backgroundSize: 'contain',
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: theme.palette.primary.main,
}));

const LoginBox = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: 6,
  boxShadow: theme.shadows[24],
  padding: theme.spacing(4),
  maxWidth: 400,
  width: '100%',
}));

const Login = () => {
  const navigate = useNavigate();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const [loading, setLoading] = useState(false);

  const devideRedirect = () => {
    navigateTo('/dashboard');
  }

  const navigateTo = (path) => {
    window.history.pushState({}, '', path);
    window.dispatchEvent(new PopStateEvent('popstate'));
    window.location.reload();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      const { token, refreshToken } = await authService.login(username, password);

      localStorage.setItem('username', username);
      localStorage.setItem('token', token);
      localStorage.setItem('refreshToken', refreshToken);

      setLoading(false);
      devideRedirect();
    } catch (error) {
      setLoading(false);
      Util.tratarCatch('E-mail ou senha inválidos', 'Login', error, navigate);
    }
  };

  return (
    <Background>
      <CssBaseline />
      <Container component="main" maxWidth="xs">
        <Box sx={{ mb: 3 }}>
          <center>
            <img src={logo} alt="Logo" style={{ width: 180 }} />
          </center>
        </Box>
        <LoginBox>
          <Typography component="h1" variant="h5">
            Entrar
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1, width: '100%' }}>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              autoFocus
              label="Usuário"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              type="password"
              label="Senha"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              size="large"
              sx={{ mt: 2, mb: 1 }}
            >
              Entrar
            </Button>
          </Box>
        </LoginBox>
      </Container>
      <LoadingOverlay open={loading} />
    </Background>
  );
}

export default Login;
